angular.module('impactx.lot').controller('RedirectAndSaveCtrl', [
    '$scope',
    '$mdDialog',
    'saveLabel',
    'noSaveLabel',
    'abortLabel',
    'message',
    'mustSave',
    'themeFactory',
    'TranslationService',
    RedirectAndSaveCtrl]);

function RedirectAndSaveCtrl($scope, $mdDialog, saveLabel, noSaveLabel, abortLabel, message, mustSave, themeFactory, TranslationService)
{
    $scope.saveLabel = saveLabel;
    $scope.noSaveLabel = noSaveLabel;
    $scope.message = message;
    $scope.abortLabel = abortLabel;
    $scope.mustSave = mustSave;
    $scope.theme = themeFactory.getTheme();
    $scope.hintTranslation = TranslationService.get("hint");

    this.cancel = function ()
    {
        $mdDialog.cancel("noSave");
    };
    this.answer = function ()
    {
        $mdDialog.hide();
    };
    this.abort = function ()
    {
        $mdDialog.cancel("abort");
    };
}